export const reportStateEnum = {
    VALIDATED: 5,
    REPORTFILLED: 10,
    REPORT: 20,
    PLANNING: 23,
    NEEDS: 30,
};

export const reportTypeEnum = {
    SITE: 10,
    ABSENT: 20,
};

export const activityStateEnum = {
    ENTERED: 3,
    VALIDATED: 5,
    SEMIVALIDATED: 6,
    VALIDATION: 7,
    REPORTFILLED: 10,
    REPORTTOUPDATE: 15,
    REPORT: 20,
    PLANNINGSENT: 22,
    PLANNING: 23,
    NEEDSIMPORTED: 24,
    NEEDSSENT: 25,
    NEEDSFILLED: 27,
    NEEDS: 30,
};

export const versionTypeEnum = {
    WEB: 1,
    MOBILE: 2,
};

export const specialUserTypeEnum = {
    USER: 1,
    SITE: 2,
    TRUCK: 3,
    AMPLIROLL: 4,
    HEAVYTRANSPORTER: 5,
};

export const permissionLevels = {
    ADMIN: 0,
    SUPERVISION: 1,
    PLANNING: 2,
    CONDUC: 3,
    ETUDES: 10,
    OBSERVERS: 15,
    TERRAIN: 30,
    CHAUFFEUR: 35,
};

export const truckMode = {
    APPRO: 0,
    EVAC: 1,
    TRANSFER: 2,
    ONSITE: 3,
    POSE: 4,
    ENLEVEMENT: 5,
    ROTATION: 6,
    DOUBLEFRET: 7,
    BACKANDFORTH: 8,
};
export const dumpsterMode = {
    POSE: 'pose',
    ROTATION: 'rotation',
    ENLEVEMENT: 'enlevement',
};
export const stateProC = {};

export const formTemplateStatusEnum = {
    DRAFT: 1,
    PUBLISHED: 5,
    INACTIVE: 15,
};

export const questionTypeEnum = {
    TEXT_SHORT: 1,
    TEXT_LONG: 2,
    SINGLE_CHOICE: 3,
    MULTIPLE_CHOICE: 4,
};

export const filters = {
    SITE: 'site',
    JOB: 'job',
};
export const materialState = {
    NEW: 0,
    PRESENT: 5,
    REMOVE: 10,
};
export const crudStatus = {
    OK: 1,
    INACTIVE: 5,
    DELETED: 10,
};
export const localStorageKeys = {
    DATE: 'date',
    SUMMARYDATE: 'summaryDate',
    SIDEBAR: 'sideBar',
    THEME: 'theme',

    SUPERVISIONREPORTUSERID: 'supervisionReportUserId',
    SUPERVISIONREPORTSITEID: 'supervisionReportSiteId',
    SUPERVISIONMYSITES: 'supervisionMySites',
    REPORTINGSTARTDATE: 'reportingStartDate',
    REPORTINGENDDATE: 'reportingEndDate',
    REPORTINGREPORTSUSERID: 'reportingReportUserId',
    TAB: {
        NEEDS: 'needsTab',
        PLANNING: 'planningTab',
        GNR: 'gnrTab',
        SUPERVISION: 'supervisionTab',
        SUMMARY: 'summaryTab',
        VALIDATION: 'validationTab',
        EXPENSES: 'expensesTab',
        ADMINCONFIGURATION: 'adminConfigurationTab',
        ADMINMATERIAL: 'adminMaterialTab',
        ADMININTERNAL: 'adminInternalTab',
        ADMINEXTERNAL: 'adminExternalTab',
        ADMINVEHCILES: 'adminVehiclesTab',
        REPORTING: 'reportingTab',
        PLI: 'pliTab',
        FORMEDIT: 'formEditTab',
    },
    TABLE: {
        PLI: {
            MACHINES: 'machinesPliTable',
            USERS: 'usersPliTable',
            TOOLS: 'toolsPliTable',
            VEHICLES: 'vehiclesPliTable',
            TRUCKS: 'trucksPliTable',
        },
        ADMIN: {
            INTERNAL: {
                USERS: 'usersInternalAdminTable',
                JOBS: 'jobsInternalAdminTable',
                SITES: 'sitesInternalAdminTable',
                ENTITIES: 'entitiesInternalAdminTable',
            },
            VEHICLES: {
                VEHICLES: 'vehiclesVehiclesAdminTable',
                VEHICLETYPES: 'vehicleTypesVehiclesAdminTable',
                TRUCKS: 'trucksVehiclesAdminTable',
                TRUCKTYPES: 'truckTypesVehiclesAdminTable',
                LOADNATURES: 'loadNaturesVehiclesAdminTable',
            },
            MATERIAL: {
                MACHINES: 'machinesMateriallAdminTable',
                MACHINETYPES: 'machinetypesMateriallAdminTable',
                TOOLS: 'toolsMateriallAdminTable',
                TOOLTYPES: 'tooltypesMateriallAdminTable',
                DUMPS: 'dumpsMateriallAdminTable',
                SUPPLIES: 'suppliesMateriallAdminTable',
                WASTE: 'wasteMateriallAdminTable',
            },
            EXTERNAL: {
                GNRSUPPLIERS: 'gnrsuppliersExternalAdminTable',
                QUARRIES: 'quarriesExternalAdminTable',
                RENTALS: 'rentalsExternalAdminTable',
                TRUCKCOMPANIES: 'truckcompaniesExternalAdminTable',
                TEMPWORKERS: 'tempworkersExternalAdminTable',
                SUBCONTRACTORS: 'subcontractorsExternalAdminTable',
                COMPANIES: 'companiesExternalAdminTable',
            },
        },
        OPERATIONS: {
            GNR: {
                REQUESTED: 'requestedGnrOperationsTable',
                PLANNED: 'plannedGnrOperationsTable',
                DELIVERED: 'deliveredGnrOperationsTable',
                CANCEL: 'cancelGnrOperationsTable',
                ARCHIVED: 'archivedGnrOperationsTable',
            },
            PLANNING: {
                GLOBAL: 'globalPlanningOperationsTable',
                AMPLIROLL: 'amplirollPlanningOperationsTable',
            },
            SUPERVISION: {
                ACTIVITIES: 'activitiesSupervisionOperationsTable',
                TRUCKS: 'trucksSupervisionOperationsTable',
            },
            VALIDATION: {
                ACTIVITIES: 'activitiesValidationOperationsTable',
                REPORTS: 'reportsValidationOperationsTable',
            },
            EXPENSES: {
                GLOBAL: 'globalExpensesOperationsTable',
            },
        },
    },
};
export const stepModes = {
    NEEDS: 1,
    PLANNING: 5,
    REPORT: 10,
    VALIDATE: 15,
};

export const gnrState = {
    REQUESTED: 1,
    IN_PROGRESS: 2,
    DELIVERED: 3,
    CANCELED: 4,
    ARCHIVED: 5,
};

export const gnrPeriod = {
    VERY_EARLY_MORNING: 1,
    MORNING: 2,
    AFTERNOON: 3,
    FULL_DAY: 4,
};

export const priceTypeEnum = {
    UNIT: 1,
    DAY: 2,
};

export const truckPriceTypeEnum = {
    UNIT: 1,
    DAY: 2,
};

export const truckRenterPriceTypeEnum = {
    UNIT: 1,
    DAY: 2,
    TON: 3,
};

export const truckGroupEnum = {
    TRUCK_8X4: 1,
    SEMIE: 2,
    AMPLIROLL: 3,
};

export const activityTypeEnum = {
    SITE: 1,
    TRUCK: 2,
    OTHER: 3,
};

export const exportTypeEnum = {
    GNR: 1,
    TEMPWORKERS: 2,
    DRIVERSAMPLIROLL: 3,
    DRIVERSTRUCKS: 4,
    SITESAMPLIROLL: 5,
    SITESTRUCKS: 6,
    MACHINES: 7,
    TOOLS: 8,
    RENTALS: 9,
    REPORTS: 10,
    SUBCONTRACTORS: 11,
    ACTIVITIES: 12,
};

export const csvDelimiterEnum = {
    COMMA: ',',
    SEMICOLON: ';',
    PIPE: '|',
};

export const systemConfigKeyEnum = {
    COMPANY_NAME: 'companyName',
    APP_NAME: 'appName',
    LOGO: 'logo',
    LOGO_SMALL: 'logoSmall',
    COMPANY_PHONE: 'companyPhone',
    COMPANY_ADDRESS: 'companyAddress',
    SUPPORT_PHONE: 'supportPhone',
    ENVIRONMENT: 'environment',
    ANNECY_TRANSFER_COEF: 'annecyTransferCoef',
    LARGE_JOURNEY_PRICE: 'largeJourneyPrice',
    CURRENCY_SYMBOL: 'currencySymbol',
    DISTANCE_UNIT: 'distanceUnit',
    DEFAULT_WORKER_WORK_TIME: 'defaultWorkerWorkTime',
    DEFAULT_DRIVER_WORK_TIME: 'defaultDriverWorkTime',
    DEFAULT_WORKER_BREAK_TIME: 'defaultWorkerBreakTime',
    DEFAULT_DRIVER_BREAK_TIME: 'defaultDriverBreakTime',
    OVERTIME_BUFFER_HOURS: 'overtimeBufferHours',
    DEFAULT_TEMPWORKER_PRICE: 'defaultTempWorkerUnitPrice',
    PAYROLL_MEAL_BASKET_CODE: 'payrollMealBasketCode',
    PAYROLL_PHONE_ALLOWANCE_CODE: 'payrollPhoneAllowanceCode',
    PAYROLL_PHONE_ALLOWANCE_AMOUNT: 'payrollPhoneAllowanceAmount',
    PAYROLL_LONG_DISTANCE_CODE: 'payrollLongDistanceCode',
    APP_WEB_URL: 'appWebUrl'
};

export const systemConfigGroupEnum = {
    COMPANY: 'company',
    APP: 'app',
    SUPPORT: 'support',
    ENV: 'env',
    PRICING: 'pricing',
    TIME: 'time',
};

export const supplyUnitEnum = {
    FT: 1,
    J: 2,
    L: 3,
    ML: 4,
    T: 5,
    TR: 6,
    U: 7,
};

export const getReportStateInfos = (state: number | undefined) => {
    switch (state) {
        case reportStateEnum.VALIDATED:
            return 'validated';
        case reportStateEnum.REPORTFILLED:
            return 'submitted';
        case reportStateEnum.REPORT:
            return 'report';
        case reportStateEnum.PLANNING:
            return 'planning';
        case reportStateEnum.NEEDS:
            return 'need';
        default:
            return '';
    }
};

export const getReportTypeInfos = (state: number | undefined) => {
    switch (state) {
        case reportTypeEnum.ABSENT:
            return 'absent';
        case reportTypeEnum.SITE:
            return 'present';
        default:
            return '';
    }
};

export const getActivityStateInfos = (state: number | undefined) => {
    switch (state) {
        case activityStateEnum.ENTERED:
            return 'validationEntered';
        case activityStateEnum.VALIDATED:
            return 'validationCompleted';
        case activityStateEnum.SEMIVALIDATED:
            return 'semiValidated';
        case activityStateEnum.VALIDATION:
            return 'validationInProgress';
        case activityStateEnum.REPORTFILLED:
            return 'reportSubmitted';
        case activityStateEnum.REPORT:
            return 'reportInProgress';
        case activityStateEnum.PLANNINGSENT:
            return 'planningSent';
        case activityStateEnum.PLANNING:
            return 'planningInProgress';
        case activityStateEnum.NEEDSIMPORTED:
            return 'needsExported';
        case activityStateEnum.NEEDSSENT:
            return 'needsSent';
        case activityStateEnum.NEEDSFILLED:
            return 'needsFilled';
        case activityStateEnum.NEEDS:
            return 'needsInProgress';
        default:
            return '';
    }
};

export const getTruckModeInfos = (mode: number | undefined) => {
    switch (mode) {
        case truckMode.APPRO:
            return 'appro';
        case truckMode.EVAC:
            return 'evac';
        case truckMode.TRANSFER:
            return 'transfer';
        case truckMode.ONSITE:
            return 'onsite';
        case truckMode.ENLEVEMENT:
            return 'enlevement';
        case truckMode.POSE:
            return 'pose';
        case truckMode.ROTATION:
            return 'rotation';
        case truckMode.DOUBLEFRET:
            return 'doubleFret';
        case truckMode.BACKANDFORTH:
            return 'backAndForth';
        default:
            return '';
    }
};

export const getMaterialStateInfos = (state: number | undefined) => {
    switch (state) {
        case materialState.NEW:
            return 'new';
        case materialState.PRESENT:
            return 'present';
        case materialState.REMOVE:
            return 'remove';
        default:
            return '';
    }
};

export const getCrudStatusInfos = (status: number | undefined) => {
    switch (status) {
        case crudStatus.OK:
            return 'active';
        case crudStatus.INACTIVE:
            return 'inactive';
        case crudStatus.DELETED:
            return 'deleted';
        default:
            return '';
    }
};

export const getPermsLvlInfos = (permsLvl: number | undefined) => {
    switch (permsLvl) {
        case permissionLevels.ADMIN:
            return 'admin';
        case permissionLevels.SUPERVISION:
            return 'supervision';
        case permissionLevels.PLANNING:
            return 'planning';
        case permissionLevels.CONDUC:
            return 'conduc';
        case permissionLevels.TERRAIN:
            return 'terrain';
        case permissionLevels.CHAUFFEUR:
            return 'driver';
        default:
            return '';
    }
};

export const getGnrPeriodInfos = (period: number | undefined) => {
    switch (period) {
        case gnrPeriod.VERY_EARLY_MORNING:
            return 'veryEarlyMorning';
        case gnrPeriod.MORNING:
            return 'morning';
        case gnrPeriod.FULL_DAY:
            return 'allDay';
        case gnrPeriod.AFTERNOON:
            return 'afternoon';
        default:
            return '';
    }
};

export const getGnrStateInfos = (state: number | undefined) => {
    switch (state) {
        case gnrState.REQUESTED:
            return 'requested';
        case gnrState.IN_PROGRESS:
            return 'planned';
        case gnrState.DELIVERED:
            return 'delivered';
        case gnrState.CANCELED:
            return 'canceled';
        case gnrState.ARCHIVED:
            return 'archived';
        default:
            return '';
    }
};

export const getPriceTypeInfos = (priceType: number | undefined) => {
    switch (priceType) {
        case priceTypeEnum.DAY:
            return 'day';
        case priceTypeEnum.UNIT:
            return 'unit';
        default:
            return '';
    }
};

export const getTruckPriceTypeLabel = (priceType: number | undefined) => {
    switch (priceType) {
        case truckPriceTypeEnum.DAY:
            return 'day';
        case truckPriceTypeEnum.UNIT:
            return 'ride';

        default:
            return '';
    }
};

export const getTruckRenterPriceTypeLabel = (priceType: number | undefined) => {
    switch (priceType) {
        case truckRenterPriceTypeEnum.DAY:
            return 'day';
        case truckRenterPriceTypeEnum.UNIT:
            return 'ride';
        case truckRenterPriceTypeEnum.TON:
            return 'ton';
        default:
            return '';
    }
};

export const getTruckGroupInfos = (billingType: number) => {
    switch (billingType) {
        case truckGroupEnum.AMPLIROLL:
            return 'ampliroll';
        case truckGroupEnum.SEMIE:
            return 'semie';
        case truckGroupEnum.TRUCK_8X4:
            return '8x4';
        default:
            return '';
    }
};

export const getSupplyUnitLabel = (unit: number): string => {
    switch (unit) {
        case supplyUnitEnum.FT:
            return 'flatRate(s)';
        case supplyUnitEnum.J:
            return 'day(s)';
        case supplyUnitEnum.L:
            return 'liter(s)';
        case supplyUnitEnum.ML:
            return 'linearMeter(s)';
        case supplyUnitEnum.T:
            return 'ton(s)';
        case supplyUnitEnum.TR:
            return 'ride(s)';
        case supplyUnitEnum.U:
            return 'unit(s)';
        default:
            return '';
    }
};

export const getVersionTypeInfos = (type: number | undefined) => {
    switch (type) {
        case versionTypeEnum.WEB:
            return 'web';
        case versionTypeEnum.MOBILE:
            return 'mobile';
        default:
            return '';
    }
};

export const getSpecialUserTypeLabel = (type: number | undefined) => {
    switch (type) {
        case specialUserTypeEnum.USER:
            return 'user';
        case specialUserTypeEnum.SITE:
            return 'site';
        case specialUserTypeEnum.TRUCK:
            return 'truck';
        case specialUserTypeEnum.AMPLIROLL:
            return 'ampliroll';
        case specialUserTypeEnum.HEAVYTRANSPORTER:
            return 'heavyTransporter';
        default:
            return '';
    }
};

export const getFormTemplateStatusLabel = (type: number | undefined) => {
    switch (type) {
        case formTemplateStatusEnum.DRAFT:
            return 'draft';
        case formTemplateStatusEnum.PUBLISHED:
            return 'published';
        case formTemplateStatusEnum.INACTIVE:
            return 'inactive';
        default:
            return '';
    }
};

export const getQuestionTypeLabel = (type: number | undefined) => {
    switch (type) {
        case questionTypeEnum.TEXT_SHORT:
            return 'shortAnswer';
        case questionTypeEnum.TEXT_LONG:
            return 'longAnswer';
        case questionTypeEnum.MULTIPLE_CHOICE:
            return 'multipleChoice';
        case questionTypeEnum.SINGLE_CHOICE:
            return 'singleChoice';

        default:
            return '';
    }
};

export const getPriceTypeConfig = (priceType: number) => {
    switch (priceType) {
        case truckRenterPriceTypeEnum.DAY:
            return { step: 0.5, min: 0, decimals: 1, max: 1 };

        case truckRenterPriceTypeEnum.TON:
            return { step: 0.01, min: 0, decimals: 2 };

        case truckRenterPriceTypeEnum.UNIT:
        default:
            return { step: 1, min: 0, decimals: 0 };
    }
};
